import { Route } from "@angular/router";

import { AuthGuard } from "@lantern/app/core/auth";

import { NoPermissionPageComponent } from "./no-permission.component";

export const routes: Route[] = [
  {
    path: "no-permission",
    component: NoPermissionPageComponent,
    data: {
      AUTH_GUARD_PERMISSION: "true",
      AUTH_GUARD_REDIRECT: "/go-login"
    },
    canActivate: [AuthGuard]
  }
];
